import { useRouter } from 'next/router'
import { getCreateMapLink } from 'utils'

import SearchMapsInput from './SearchMapsInput'
import TagPicker from './TagPicker'
import View from './view'

import { useIsWorkspaceMember, useWorkspace } from '~workspace/states/workspace'

const MapsTabTools = (props) => {
  const router = useRouter()
  const workspace = useWorkspace()
  const isWorkspaceMember = useIsWorkspaceMember()

  const gotoCreateMap = () => {
    router.push(
      getCreateMapLink({
        workspaceId: workspace.id,
        workspaceName: workspace.name
      })
    )
  }

  const handleCreateMapClick = () => {
    if (!isWorkspaceMember) return
    gotoCreateMap()
  }

  return (
    <View
      {...props}
      canCreateMap={isWorkspaceMember}
      searchMapsInput={SearchMapsInput}
      tagPicker={TagPicker}
      onCreateMapClick={handleCreateMapClick}
    />
  )
}

export { MapsTabTools }
export default MapsTabTools
